<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">
      When renewing I received one of the following messages. What do they mean?
    </div>
    <div slot="content">
      <ul>
        <li>Vehicle Registration Is Suspended</li>
        <li>Vehicle Has Been Dismantled</li>
        <li>Registration Has Been Transferred</li>
        <li>Vehicle Is Title Purpose Only</li>
        <li>Vehicle Has Been expired For More Than One Year</li>
        <li>Reg Only and Renewal are Stopped Due to Title Suspense</li>
        <li>Account Has A Balance Due</li>
        <li>Stop Process on Account</li>
        <li>Not Eligible for 'x' year(s) renewal</li>
        <li>
          Vehicle Has Not Been Assessed. Please contact your county assessor
        </li>
        <li>
          Property Taxes Have Not Been Paid. Please contact your county
          collector
        </li>
        <li>
          Registration Has Been Transferred has been changed to License plate is
          not active
        </li>
        <li>Valid Insurance information not found for this vehicle</li>
      </ul>
      <p>
        You are not eligible to renew online and will have to <a
          rel="external"
          href="https://www.dfa.arkansas.gov/office-locations/revenue-offices"
          title="Find your local Revenue Office"
          >visit or contact your local Revenue Office</a
        >.
      </p>
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">What do I need to renew my registration online?</div>
    <div slot="content">
      You will need your Renewal Reminder with the Renewal Identification Number
      and the Verification Code. If you do not have the Renewal Reminder you can
      renew your registration with the Last 4 Digits of your Vehicle
      Identification Number (VIN), License Plate Number and Zip Code. You will
      need a valid credit card or electronic check information for payment.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      What If I did not receive a Renewal Notice in the mail?
    </div>
    <div slot="content">
      You can renew your registration with the Last 4 Digits of your Vehicle
      Identification Number (VIN), License Plate Number and Zip Code. When
      renewing ensure that your address is up to date for the Registration
      Renewal.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">How long will it take to process my renewal?</div>
    <div slot="content">
      Please allow a minimum of 5 business days for mail delivery of your
      decal(s).
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">Where would I find my VIN?</div>
    <div slot="content">
      In most vehicles the VIN is located on the dashboard or on your vehicle
      registration document.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Do I have to have valid liability insurance, current year assessment and
      personal property taxes paid for the current year?
    </div>
    <div slot="content">
      Yes, before renewing your vehicle license plate, you are required by
      Arkansas Law to maintain liability insurance, assess your vehicle with
      your county assessor and pay all personal property taxes you owe.
    </div>
  </AccordionItem>
</AccordionGroup>
